/* eslint-disable import/no-duplicates */
/* eslint-disable import/no-default-export */
import { combineReducers } from 'redux'
import canBusTypes from './canBusTypes'
import translations from './translations'
import errors from './errors'
import deviceSerialNumber from './deviceSerialNumber'
import licensePlate from './licensePlate'
import wfSubscription from './wfSubscription'
import choosedPropertyType from './choosedPropertyType'
import activationCode from './activationCode'
import customerNumber from './customerNumber'
import contractNumber from './contractNumber'
import tariffs from './tariffs'
import rmaDevices from './rmaDevices'
import fetchTranslateSuccess from './fetch'
import fetchProcessSuccess from './fetch'
import deviceActivationKey from './deviceActivationKey'
import subscriptionSelectedPage from './subscriptionSelectedPage'
import selectedSubscriptionOption from './selectedSubscriptionOption'
import rmaDeviceSerialNumber from './rmaDeviceSerialNumber'
import providerNo from './providerNo'
import generationRequired from './generations-select/generation-required'
import isDakDevice from './is-dak-device'

import brands from './generations-select/brands'
import models from './generations-select/models'
import generations from './generations-select/generations'
import generationSelected from './generations-select/generation-selected'
import generationIdSelected from './generations-select/generation-id-selected'
import generationObject from './generations-select/generation-object'
import brandId from './generations-select/selectibles/brand'
import modelId from './generations-select/selectibles/model'
import fuelTypeIndex from './generations-select/selectibles/fueltype-index'
import fuelTypesGroup from './generations-select/selectibles/fueltypes-group'
import tankSize from './tankSize'

export default combineReducers({
    activationCode,
    brandId,
    brands,
    canBusTypes,
    choosedPropertyType,
    contractNumber,
    customerNumber,
    deviceActivationKey,
    deviceSerialNumber,
    errors,
    fetchProcessSuccess,
    fetchTranslateSuccess,
    fuelTypeIndex,
    fuelTypesGroup,
    generationIdSelected,
    generationObject,
    generationRequired,
    generationSelected,
    generations,
    isDakDevice,
    licensePlate,

    modelId,
    models,
    providerNo,
    rmaDeviceSerialNumber,
    rmaDevices,
    selectedSubscriptionOption,
    subscriptionSelectedPage,
    tankSize,
    tariffs,
    translations,
    wfSubscription
})
